class B2BDetailsTabs extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.panels = [...this.querySelectorAll('[data-tab-panel]')].filter(p => p.closest('b2b-details-tabs') === this);
    const nav = this.querySelector('.b2b-details-tabs__nav');
    if (!nav) return;
    nav.replaceChildren();
    this.buttons = this.panels.map((panel, index) => {
      const button = document.createElement('button');
      button.type = 'button'; button.id = `${panel.id}-button`; button.textContent = panel.dataset.title;
      button.setAttribute('role','tab'); button.setAttribute('aria-controls',panel.id);
      panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',button.id); panel.tabIndex = 0;
      panel.querySelector('[data-tab-fallback]').hidden = true;
      button.addEventListener('click',()=>this.select(index),{signal});
      button.addEventListener('keydown',event=>{
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.panels.length-1 : (index+(event.key === 'ArrowRight' ? 1 : -1)+this.panels.length)%this.panels.length;
        this.select(next); this.buttons[next].focus({preventScroll:true});
      },{signal});
      nav.append(button); return button;
    });
    nav.hidden = this.panels.length === 0;
    this.select(0, false);
    this.addEventListener('shopify:block:select',event=>{
      const index = this.panels.findIndex(panel=>panel === event.target || panel.contains(event.target));
      if(index >= 0) this.select(index);
    },{signal});
  }
  select(index, scroll = true) {
    this.panels.forEach((panel,i)=>{ panel.hidden=i!==index; this.buttons[i].setAttribute('aria-selected',String(i===index)); this.buttons[i].tabIndex=i===index?0:-1; });
    if (scroll && this.buttons[index]) {
      const button=this.buttons[index], nav=button.parentElement;
      const buttonRect=button.getBoundingClientRect(), navRect=nav.getBoundingClientRect();
      nav.scrollTo({left:nav.scrollLeft+buttonRect.left-navRect.left-(nav.clientWidth-buttonRect.width)/2,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('b2b-details-tabs')) customElements.define('b2b-details-tabs',B2BDetailsTabs);
